var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPayout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.78,20.07v2.17c-1.72,.37-3.19,1.77-3.58,3.44-.25,1.08-.24,3.13,2.74,4.79,.46,.26,.99,.5,1.55,.76,2.88,1.33,4.07,2.17,3.54,3.7-.39,1.09-1.41,1.51-1.98,1.66-1.22,.32-2.59,.05-3.41-.68-.43-.38-.72-.89-.83-1.48l-2.37,.43c.2,1.11,.78,2.13,1.61,2.86,.75,.65,1.71,1.09,2.74,1.29v2.17h2.41v-2.18c.15-.03,.31-.05,.46-.09,1.76-.46,3.09-1.62,3.64-3.19,1.36-3.86-2.5-5.64-4.8-6.7-.52-.24-1-.46-1.38-.67-1.21-.68-1.74-1.4-1.57-2.14,.19-.79,.96-1.5,1.8-1.66,1.31-.24,2.69,.41,3.23,1.53l2.17-1.05c-.68-1.41-2.03-2.4-3.55-2.77v-2.22h-2.41Z",
    fill: "#000000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.4,19.88L25.41,4.79c-.84-.84-2.3-.84-3.13,0L7.28,19.88c-.63,.63-.81,1.57-.47,2.4,.34,.82,1.14,1.36,2.03,1.36h3.92v19.97h3V20.64h-5L23.84,7.47l13.09,13.17h-5v22.97h3V23.64h3.91c.89,0,1.69-.54,2.04-1.36,.34-.82,.15-1.77-.48-2.4Z",
    fill: "#000000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.21,28.79c-.16-.27-.54-.27-.7,0l-2.92,5.05c-.16,.27,.04,.61,.35,.61h1.42v9.34h3v-9.34h1.42c.31,0,.51-.34,.35-.61l-2.92-5.05Z",
    fill: "#000000"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M45.05,33.84l-2.92-5.05c-.16-.27-.54-.27-.7,0l-2.92,5.05c-.16,.27,.04,.61,.35,.61h1.42v9.34h3v-9.34h1.42c.31,0,.51-.34,.35-.61Z",
    fill: "#000000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPayout);
export default __webpack_public_path__ + "static/media/icon_payout.8722da52d75d7228dfbb2efbe8a8ee6c.svg";
export { ForwardRef as ReactComponent };